
import type { Result } from '@empathyco/x-types'
import type { PropType } from 'vue'
import { computed, defineComponent } from 'vue'
import { useQueryRankingElementActionsConfig } from './../composables/use-query-ranking-element-actions-config'
import { ExplainUtils } from './../utils'
import { EpbBadge } from './shared/epb-badge'

export default defineComponent({
  name: 'ResultCardFooter',
  components: {
    EpbBadge,
  },
  props: {
    result: {
      type: Object as PropType<Result>,
      required: true,
    },
    hovered: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
    haveHiddenProducts: Boolean,
  },
  setup: props => {
    const baseClass = 'epb-result-card-footer'
    const { getActionConfig } = useQueryRankingElementActionsConfig()

    const actionConfig = computed(() => {
      const action = ExplainUtils.getQueryRankingConfigActionFromResult(
        props.result,
        props.haveHiddenProducts,
      )

      return action ? getActionConfig(action) : undefined
    })

    const classes = computed((): string[] => {
      return [
        ...[baseClass],
        ...(props.hovered ? [`${baseClass}--hovered`] : []),
        ...(actionConfig.value ? [`${baseClass}__${actionConfig.value.action.toLowerCase()}`] : []),
      ]
    })
    return { baseClass, actionConfig, classes }
  },
})
